/**
 * design-tools/useLenis.js
 * Lenis smooth scroll — emits scroll events for useScrollProgress compatibility
 */
import { useEffect, useRef } from 'react';

export function useLenis() {
  const lenisRef = useRef(null);

  useEffect(() => {
    if (!window.Lenis) {
      console.warn('[useLenis] Lenis not found on window.');
      return;
    }

    const lenis = new window.Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 0.9,
      touchMultiplier: 1.5,
      infinite: false,
      prevent: (node) => node.closest('[data-lenis-prevent]') !== null,
    });

    lenisRef.current = lenis;
    window.__lenis = lenis;

    // Emit a native scroll event on each Lenis scroll tick so
    // useScrollProgress (which listens to window scroll) stays in sync
    lenis.on('scroll', ({ scroll }) => {
      // Dispatch a synthetic scroll event so passive listeners fire
      window.dispatchEvent(new Event('scroll', { bubbles: false }));
    });

    let raf;
    function tick(time) {
      lenis.raf(time);
      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return lenisRef;
}
